// 앱 식별자 (legacy/index.html 기준)
export const APP_STORE_ID = '1545104069';
export const PLAY_STORE_PACKAGE = 'com.woorien.wrapp';

export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;

// 새 랜딩 도메인 (Universal Link / App Link 미등록 → 인앱 브라우저에 노출 강제)
//
// NOTE: 현재 (preview/prod 모두) applink.woorien.com 도메인을 그대로 재사용한다.
// 앱이 16개 deep link path 를 `applink.woorien.com` 으로 받도록 등록되어 있고,
// `buildDeepLinkTarget` 가 `window.location.href` 를 그대로 사용하기 때문이다.
// m.woorien.com 으로의 도메인 분리는 향후 검토 항목.
export const LANDING_HOST = 'applink.woorien.com';
